module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"add":"@:labels.add","addMore":"@:labels.addMore","attributionLabel":"Attribution","required":"@:labels.required","successTitle":"Successfully Added","title":"Add User"},"fr":{"add":"@:labels.add","addMore":"@:labels.addMore","attributionLabel":"Attribution","required":"@:labels.required","successTitle":"Ajouté avec succès","title":"Ajouter un utilisateur"}}')
  delete Component.options._Ctor
}
